import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { AssignedUnitShiftStatus } from '@/models';

export const useStyles = makeStyles((theme: Theme) => ({
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: 'transparent',
    padding: '12px 40px 12px 40px',
    zIndex: 1000,
    transition: 'transform 0.3s ease-in-out',
    flex: 1,
    pointerEvents: 'auto',
  },
  sidebarFull: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: 'transparent',
    padding: '12px 40px 12px 40px',
    zIndex: 1000,
    transition: 'transform 0.3s ease-in-out',
    flex: 1,
    pointerEvents: 'auto',
  },
  '@global': {
    // This rule targets any div that is a direct parent of an element with the 'fixed-sidebar-class' class
    'div:has(> .fixed-sidebar-class)': {
      pointerEvents: 'none',
    },
  },
  sidebarContent: {
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    flex: 1,
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '24px',
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  filterButton: {
    boxShadow: '10px 10px 50px 0px #0000001A',
    position: 'absolute',
    top: '1%',
    left: -48,
    width: '44px',
    height: '44px',
    borderRadius: '8px',
    backgroundColor: `${theme.palette.background.paper} !important`,
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  toggleButton: {
    boxShadow: '10px 10px 50px 0px #0000001A',
    position: 'absolute',
    top: '50%',
    left: -48,
    width: '44px',
    height: '44px',
    borderRadius: '8px',
    backgroundColor: `${theme.palette.background.paper} !important`,
    pointerEvents: 'auto',
  },
  contollButtons: {
    position: 'absolute',
    bottom: 210,
    left: -48,
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    pointerEvents: 'auto',
  },
  controllButton: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    width: '44px !important',
    height: '44px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '10px 10px 50px 0px #0000001A',
  },
  topButtonGroup: {
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
  bottomButtonGroup: {
    borderBottomLeftRadius: '50%',
    borderBottomRightRadius: '50%',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  },
  locate: {
    borderRadius: '50%',
    marginBottom: 10,
    marginTop: 10,
  },
  // Blinking animation class
  blinking: {
    animation: '$blink 1.5s infinite',
  },
  // Keyframe animation for blinking
  '@keyframes blink': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.3,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export const customRequestBackupStyles = {
  backgroundColor: '#46DBB1',
  paddingY: 1.5,
  fontWeight: 500,
  fontSize: 16,
  color: 'white',
  '&:hover': {
    backgroundColor: '#33C299',
  },
};

export interface StatusColorConfig {
  className: string;
}

export const getStatusColorConfig = (
  status: AssignedUnitShiftStatus,
): StatusColorConfig => {
  switch (status) {
    case AssignedUnitShiftStatus.COMPLETED:
    case AssignedUnitShiftStatus.CANCELED:
      return {
        className: 'bg-black text-gray-300',
      };
    case AssignedUnitShiftStatus.EN_ROUTE:
    case AssignedUnitShiftStatus.ON_SCENE:
    case AssignedUnitShiftStatus.ASSIGNED:
    case AssignedUnitShiftStatus.IN_THE_AREA:
    case AssignedUnitShiftStatus.PROGRESS:
      return {
        className: 'bg-blue-100 text-blue-800',
      };
    default:
      return {
        className: 'bg-gray-100 text-gray-800',
      };
  }
};

export const getStatusColorClass = (color: string): string => {
  switch (color) {
    case 'info':
      return 'bg-blue-100 text-blue-800';
    case 'success':
      return 'bg-black text-gray-300';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
